import { createSupport } from './createSupport'
import { getAllSupports } from './getAllSupports'

export const supportService = {
  getAllSupports,
  createSupport,
}
